import gsap from "gsap";
import { useEffect, useRef, useState } from "react";
import { useScroll } from "../../hooks/use-scroll";
import { useRect } from "../../hooks/use-rect";
import { useWindowSize } from "react-use";
import { mapRange, clamp } from "../../utils/Maths";
import { useTranslation } from "react-i18next";

import s from "./Discover.module.scss";
import { useStore } from "../../store/store";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

const Discover = () => {
  const elementRef = useRef(null);
  const innerRef = useRef(null);
  const { t } = useTranslation();

  const [wrapperRectRef, wrapperRect] = useRect();
  const [elementRectRef, elementRect] = useRect();

  const { height: windowHeight } = useWindowSize();

  const [windowWidth, setWindowWidth] = useState();
  const setDiscoverThreshold = useStore((state) => state.setDiscoverThreshold);
  const setDisplayChair = useStore((state) => state.setDisplayChair);
  const bowser = useStore((state) => state.bowser);

  useScroll(({ scroll }) => {
    if (!elementRect || !elementRef.current) return;

    const start = wrapperRect.top - windowHeight * 0.5;
    const end = wrapperRect.top + wrapperRect.height - windowHeight;

    let progress = mapRange(start, end, scroll, 0, 1);
    progress = clamp(0, progress, 1);

    const x = windowWidth - (elementRect.width + windowWidth * 1.02) * progress;

    gsap.to(elementRef.current, {
      x: x,
      ease: "none",
      duration: 0,
    });
  });

  useEffect(() => {
    // console.log(wrapperRect.top);
    setDiscoverThreshold({
      start: wrapperRect.top - windowHeight * 0.5,
      end: wrapperRect.top + wrapperRect.height - windowHeight,
    });
  }, [elementRect]);

  useEffect(() => {
    // const sentence = "Discover Miss Dior";
    const sentence = t("discover");
    const letters = sentence.split("");

    letters.forEach((letter) => {
      const span = document.createElement("span");
      span.innerHTML = letter;

      if (letter === " ") {
        span.classList.add(s.space);
      }

      elementRef.current.appendChild(span);
    });

    gsap.fromTo(
      elementRef.current.children,
      {
        opacity: 0.14,
        rotateX: window.innerWidth < 1024 ? 0 : -90,
        z: -100,
      },
      {
        ease: "none",
        opacity: 0.2,
        rotateX: 0,
        z: 0,
        stagger: 0.1,
        scrollTrigger: {
          start: "-300px top",
          end: `+=${3 * 100}%`,
          scrub: true,
          // markers: {},
          trigger: innerRef.current,
        },
      }
    );

    const trigger = ScrollTrigger.create({
      trigger: document.getElementById("discover"),
      start: "top 50%",
      // end: `+=${4 * 100}%`,
      end: "75% top",
      // markers: {},
      onEnter: () => {
        // console.log("on enter");
        setDisplayChair("enter");
      },
      onEnterBack: () => {
        // console.log("on enter");
        setDisplayChair("enterBack");
      },
      onLeave: () => {
        // console.log("on leave");
        setDisplayChair("leave");
        // setDisplayChair(false);
      },
      onLeaveBack: () => {
        setDisplayChair("leaveBack");
        // setDisplayChair(false);
        // console.log("leave back");
      },
    });

    const onResize = () => {
      setWindowWidth(
        Math.min(window.innerWidth, document.documentElement.offsetWidth)
      );
    };

    window.addEventListener("resize", onResize, false);
    onResize();

    return () => {
      window.removeEventListener("resize", onResize, false);
    };
  }, []);

  return (
    <div ref={wrapperRectRef} className={s.discover} id="discover">
      <div ref={innerRef} className={s.inner}>
        <h1
          ref={(node) => {
            elementRef.current = node;
            elementRectRef(node);
          }}
        ></h1>
      </div>
    </div>
  );
};

export default Discover;
